import { Box, Divider, Picture, Typography } from "@jewlr/storybook/core"

import Modal from "components/modal"
import { jewlr_t } from "helpers/application"

const HonestPricingModal = () => (
  <Modal
    label="Jewlr vs. Traditional Retailer"
    show="#honest-pricing"
    variant="squircle"
    width="790px"
  >
    <Box textAlign="center">
      <Typography
        fontSize={{ _: "20px", tablet: "25px" }}
        fontWeight="300"
        lineHeight={{ _: "24px", tablet: "36px" }}
        mb={{ _: 4, tablet: 3 }}
        textAlign="center"
      >
        We eliminated the middle steps, allowing us to drive value to our
        customers.
      </Typography>
      <Picture
        alt={`At Jewlr, we manufacture our ${jewlr_t(
          "terms.jewelry"
        )} in Canada and sell it online directly to our customers, eliminating the middle steps so you get quality products at low prices, every day.`}
        fallback={require("images/product/honest_pricing/jewlr-model-flow.svg")}
        mb={{ _: 4, tablet: 0 }}
        mx="auto"
        srcSet={[
          {
            height: "181",
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require("images/product/honest_pricing/m-jewlr-pricing-model.svg")} 321w`,
            width: "321",
          },
          {
            height: "214",
            media: "(min-width: 768px)",
            sizes: "562px",
            srcSet: `${require("images/product/honest_pricing/jewlr-model-flow.svg")} 562w`,
            width: "562",
          },
        ]}
        width={{ _: "100%", tablet: "562px" }}
      />
      <Divider color="black" display={{ _: "none", tablet: "block" }} mb={3} />
      <Picture
        alt="In traditional retail, products go from manufacturing to wholesale to distributors to retail stores – each step adds more costs, resulting in higher everyday pricing for customers."
        fallback={require("images/product/honest_pricing/traditional-model-flow.svg")}
        mx="auto"
        srcSet={[
          {
            height: "288",
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require("images/product/honest_pricing/m-traditional-retail-model.svg")} 329w`,
            width: "329",
          },
          {
            height: "186",
            media: "(min-width: 768px)",
            sizes: "684px",
            srcSet: `${require("images/product/honest_pricing/traditional-model-flow.svg")} 684w`,
            width: "684",
          },
        ]}
        width={{ _: "100%", tablet: "684px" }}
      />
    </Box>
  </Modal>
)

export default HonestPricingModal
